module.exports = __webpack_public_path__ + "img/caffeelawfirm.fd02d9de.png";